import React, { useState } from 'react';
import { useAuth } from './../contexts/AuthContext';
import './AdminLayout.css';

const AdminLayout = ({ children, currentPage, setCurrentPage, user }) => {
  const { logout } = useAuth();
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊', role: ['admin'] },
    { id: 'avaliacaoprojeto', label: 'Avaliação dos Projetos', icon: '📊', role: ['admin', 'avaliadorprojeto'] },
    { id: 'avaliacaodocumento', label: 'Avaliação dos Documentos', icon: '📊', role: ['admin', 'avaliadordocumento'] },
    { id: 'usuarioadmin', label: 'Criar Usuário', icon: '📊', role: ['admin'] },
    // { id: 'etapas', label: 'Etapas', icon: '📋' },
    // { id: 'escolaridades', label: 'Escolaridades', icon: '🎓' },
    // { id: 'eixos', label: 'Eixos', icon: '🎯' },
    // { id: 'cursos', label: 'Cursos', icon: '📚' },
    // { id: 'turmas', label: 'Turmas', icon: '👥' },
    { id: 'inscricoes', label: 'Inscrições', icon: '📝', role: ['admin'] } ,
    { id: 'eventos', label: 'Eventos', icon: '🏷️', role: ['admin'] },
    // { id: 'temas', label: 'Temas', icon: '⚙️' },
    // { id: 'tema-campos', label: 'Campos do Tema', icon: '⚙️' },
    { id: 'evento-campos', label: 'Campos do Evento', icon: '⚙️', role: ['admin'] },
    { id: 'arquivos', label: 'Arquivos', icon: '📁', role: ['admin'] },
  ];

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside onMouseOver={() => setIsCollapsed(prev => !prev)} onMouseOut={() => setIsCollapsed(prev => !prev)} className={`admin-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <h2>Admin</h2>
          <button
            type="button"
            className="collapse-toggle"
            onClick={() => setIsCollapsed(prev => !prev)}
            title={isCollapsed ? 'Expandir menu' : 'Recolher menu'}
          >
            {isCollapsed ? '➡️' : '⬅️'}
          </button>
          {user && (
            <div className="user-info">
              <div className="user-name">{user.nome || user.email}</div>
              <div className="user-role">{user.role || 'Usuário'}</div>
            </div>
          )}
        </div>
        
        <nav className="sidebar-nav">
          {menuItems.map(item => {console.log(user); return (
            item?.role?.includes(user.role) && <button
              key={item.id}
              className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
              onClick={() => setCurrentPage(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </button>
          )})}
        </nav>
        
        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-btn">
            <span>🚪</span>
            <span>Sair</span>
          </button>
          <a href="/" className="back-btn">
            <span>🏠</span>
            <span>Voltar ao Site</span>
          </a>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <header className="admin-header">
          <div className="header-content">
            <h1>
              {menuItems.find(item => item.id === currentPage)?.label || 'Dashboard'}
            </h1>
            {user && (
              <div className="header-user">
                <span>Olá, {user.nome || user.email}!</span>
              </div>
            )}
          </div>
        </header>
        
        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
